interface BaseAction<T extends string> {
  type: T;
}
interface BaseActionWithPayload<T extends string, P> extends BaseAction<T> {
  payload: P;
}
type showAction = BaseActionWithPayload<'is-show', { isShow: boolean }>;
type scrolledAction = BaseActionWithPayload<'scrolled', { scrolled: boolean }>;
type errorAction = BaseActionWithPayload<'error', { isError: boolean }>;
type initedAction = BaseActionWithPayload<'inited', { inited: boolean }>;
type timeoutInitAction = BaseActionWithPayload<
  'timeout-init',
  { timeoutInit: boolean }
>;

export type Action =
  | showAction
  | scrolledAction
  | errorAction
  | initedAction
  | timeoutInitAction;

export const showAction = (isShow: boolean): showAction => ({
  type: 'is-show',
  payload: {
    isShow,
  },
});

export const scrolledAction = (): scrolledAction => ({
  type: 'scrolled',
  payload: {
    scrolled: true,
  },
});

export const initedAction = (): initedAction => ({
  type: 'inited',
  payload: {
    inited: true,
  },
});

export const errorAction = (): errorAction => ({
  type: 'error',
  payload: {
    isError: true,
  },
});

export const timeoutInitAction = (): timeoutInitAction => ({
  type: 'timeout-init',
  payload: {
    timeoutInit: true,
  },
});
